// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/stylus-loader/index.js??ref--4-2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CartXsellItem.vue?vue&type=style&index=0&id=478838ec&scoped=true&lang=stylus&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("5affe1d6", content, true, {});